import createFieldArraySelect from 'pages/widgets/form/field-array-select'
import SendEmailField from './twitter/send-email'
import CallEndpointField from './twitter/call-endpoint'
import SendReplyField from './twitter/send-reply'
import SendTweetField from './twitter/send-tweet'
import AddMosaicField from './twitter/add-to-mosaic'
import SendOverlayField from './twitter/send-overlay'
import TriggerBlastField from './twitter/trigger-blast'
import FacebookCommentFields from './facebook/facebook-comment'
import GoogleAnalyticsTrackEventField from './twitter/google-analytics-track-event'
import GoogleSheetAppendField from './common/google-sheet-append'
import FacebookDmFields from './facebook/facebook-dm'
import FacebookOneTimeConsentFields from './facebook/facebook-onetime-consent'
import FacebookRecurringConsentFields from './facebook/facebook-recurring-consent'
import FacebookOptOutOneTimeFields from './facebook/facebook-optout-onetime'
import FacebookOptOutRecurringFields from './facebook/facebook-optout-recurring'
import FacebookSendBlastFields from './facebook/send-facebook-blast'
import InstagramCommentReplyFields from './instagram/instagram-comment-reply'
import SendInstagramDmFields from './instagram/send-instagram-dm'
import StartSpeedThread from './twitter/start-speed-thread'
import StopSpeedThread from './twitter/stop-speed-thread'
import ResetSpeedThread from './twitter/speed-thread-reset'

const TwitterActions = createFieldArraySelect({
  platform: 'twitter',
  label: 'Select an action',
  options: {
    'Send email': SendEmailField,
    'Send reply': SendReplyField,
    'Send Tweet': SendTweetField,
    'Add to mosaic': AddMosaicField,
    'Send overlay': SendOverlayField,
    'Call endpoint': CallEndpointField,
    'Trigger blast': TriggerBlastField,
    'Opt user in': null,
    'Opt user out': null,
    'Mosaic opt out': null,
    'Google Sheet Append': GoogleSheetAppendField,
    'Google Analytics Track Event': GoogleAnalyticsTrackEventField,
    'Start Speed Thread': StartSpeedThread,
    'Stop Speed Thread': StopSpeedThread,
    'Reset Speed Thread': ResetSpeedThread,
    'Add Timed Thread Activity': null
  }
}).FieldItems

const InstagramActions = createFieldArraySelect({
  platform: 'instagram',
  label: 'Select an action',
  options: {
    'Google Sheet Append': GoogleSheetAppendField,
    'Send Instagram Comment Reply': InstagramCommentReplyFields,
    'Send Instagram DM': SendInstagramDmFields
  }
}).FieldItems

const FacebookActions = createFieldArraySelect({
  platform: 'facebook',
  label: 'Select an action',
  options: {
    'Google Sheet Append': GoogleSheetAppendField,
    'Send Facebook Comment': FacebookCommentFields,
    'Send Facebook DM': FacebookDmFields,
    'Send Facebook One Time Consent': FacebookOneTimeConsentFields,
    'Send Facebook Recurring Consent': FacebookRecurringConsentFields,
    'Send Facebook Blast': FacebookSendBlastFields,
    'Opt FB User in': null,
    'Opt FB User out': FacebookOptOutOneTimeFields,
    'Opt FB User in - Recurring': null,
    'Opt FB User out - Recurring': FacebookOptOutRecurringFields
  }
}).FieldItems

export { TwitterActions, InstagramActions, FacebookActions }



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/index.js